import { useFretboardConfigStore } from '@/features/fretboard-base';
import React from 'react';

export const TrapezoidScalingSelector: React.FC = () => {
  const useTrapezoidScaling = useFretboardConfigStore((state) => state.useTrapezoidScaling);
  const setUseTrapezoidScaling = useFretboardConfigStore((state) => state.setUseTrapezoidScaling);

  const handleChange = () => {
    setUseTrapezoidScaling(!useTrapezoidScaling);
  };

  return (
    <div className="form-control w-full mb-3 max-w-full">
      <label className="label">
        <span className="label-text">Tapered Fretboard View</span>
      </label>
      <div className="flex items-center justify-between">
        <span className="text-sm opacity-70">{useTrapezoidScaling ? 'Realistic' : 'Uniform'}</span>
        <input
          type="checkbox"
          className="toggle toggle-primary"
          checked={useTrapezoidScaling}
          onChange={handleChange}
        />
      </div>
    </div>
  );
};
